/* Dr.Primal — the capture popup's analytics adapter: PostHog.

   Registers as `analytics` with `dp-capture.js`. `track(event, props)` returns nothing
   and never throws: with PostHog absent, or the visitor opted out, it does nothing.
   PostHog's consent state is set by `dp-consent.js`, which the engine waits for before
   the popup's first event, so this file does not second-guess it beyond not calling a
   PostHog that has already been opted out.

   The funnel is anonymous by design. Whatever a step passes in, an email address never
   reaches PostHog: a prop whose key names one is dropped, a string value shaped like one
   is dropped, and anything that is not a string, number or boolean is dropped, since a
   nested object could carry one past both checks. */
(function () {
  'use strict';

  var EMAIL_KEY = /e-?mail/i;                   // a prop key matching this is dropped whatever its value
  var EMAIL_VALUE = /[^\s@]+@[^\s@]+\.[^\s@]+/; // a string value containing an address is dropped

  var capture = window.dpCapture;
  if (!capture) {
    console.error('[dp-capture-posthog] dp-capture.js must load before this file');
    return;
  }

  function anonymous(props) {
    var clean = {};
    Object.keys(props || {}).forEach(function (key) {
      var value = props[key];
      var type = typeof value;
      if (EMAIL_KEY.test(key)) return;
      if (type !== 'string' && type !== 'number' && type !== 'boolean') return;
      if (type === 'string' && EMAIL_VALUE.test(value)) return;
      clean[key] = value;
    });
    return clean;
  }

  function track(event, props) {
    try {
      var posthog = window.posthog;
      if (!posthog || typeof posthog.capture !== 'function') return;
      // Before array.js loads, the head stub returns nothing here, so the call is queued
      // and PostHog applies its own consent state when it replays.
      if (typeof posthog.has_opted_out_capturing === 'function' && posthog.has_opted_out_capturing() === true) {
        return;
      }
      posthog.capture(event, anonymous(props));
    } catch (error) {
      console.error('[dp-capture-posthog]', error);
    }
  }

  capture.registerAdapter('analytics', { track: track });
})();
